import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text, TextProps } from '@backstage/ui';

const styles = createStyles({
  root: {},
});

export interface ExpressionValueProps
  extends TextProps,
    WithStyles<typeof styles> {}

const ExpressionValue = forwardRef<HTMLDivElement, ExpressionValueProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        className={classNames(className, classes.root)}
        {...rest}
      />
    );
  },
);

ExpressionValue.displayName = 'Expression.Value';

export default withStyles(styles)(ExpressionValue);
